const cartBillingAddrInfo = `
billing_address {
  city
  country {
    code
    label
  }
  region {
    code
    label
  }
  company
  firstname
  lastname
  postcode
  region {
    code
    label
  }
  street
  telephone
}
`;

export default cartBillingAddrInfo;
